module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('calling-code', {
    staticClass: "area-code"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group phone-number"
  }, [_c('label', {
    attrs: {
      "for": "phone"
    }
  }, [_vm._v(_vm._s(_vm.$t('phoneNumPlaceholder')))]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phoneNumber),
      expression: "phoneNumber"
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|numeric'),
      expression: "'required|numeric'"
    }],
    class: {
      input: true,
        'danger-border': _vm.errors.has('phone') || !!_vm.phoneErrorMessage,
    },
    attrs: {
      "type": "text",
      "name": "phone",
      "id": "phone",
      "placeholder": _vm.$t('phoneNumPlaceholder')
    },
    domProps: {
      "value": (_vm.phoneNumber)
    },
    on: {
      "change": function($event) {
        _vm.phoneErrorMessage = ''
      },
      "blur": function($event) {
        _vm.showError.phone = true
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phoneNumber = $event.target.value
      }
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('phone') && _vm.showError.phone),
      expression: "errors.has('phone') && showError.phone"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first("phone")))]), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showError.phone),
      expression: "showError.phone"
    }]
  }, [_vm._v(_vm._s(_vm.phoneErrorMessage))])])]), _vm._v(" "), _c('p', {
    staticClass: "clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": "pwd"
    }
  }, [_vm._v(_vm._s(_vm.$t('passwordPlaceholder')))]), _vm._v(" "), (!_vm.isShowPwd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      'input pwd': true,
      'danger-border': _vm.errors.has('password') || !!_vm.pwdErrorMessage,
    },
    attrs: {
      "type": "password",
      "name": "password",
      "id": "pwd",
      "placeholder": _vm.$t('passwordPlaceholder')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": [_vm.myValidate, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isShowPwd) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model.trim",
      value: (_vm.password),
      expression: "password",
      modifiers: {
        "trim": true
      }
    }, {
      name: "validate",
      rawName: "v-validate",
      value: ('required|min:6|max:20'),
      expression: "'required|min:6|max:20'"
    }],
    class: {
      input: true,
        'danger-border': _vm.errors.has('password') || !!_vm.pwdErrorMessage,
    },
    attrs: {
      "type": "text",
      "name": "password",
      "id": "pwd",
      "placeholder": _vm.$t('setPasswordPlaceholder')
    },
    domProps: {
      "value": (_vm.password)
    },
    on: {
      "blur": [_vm.myValidate, function($event) {
        return _vm.$forceUpdate()
      }],
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.password = $event.target.value.trim()
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "show-pwd",
    on: {
      "click": _vm.showPwd
    }
  }, [_c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowPwd),
      expression: "isShowPwd"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye.svg",
      "alt": ""
    }
  }), _vm._v(" "), _c('img', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isShowPwd),
      expression: "!isShowPwd"
    }],
    attrs: {
      "src": "/static/img/dashboard/ic_eye_off.svg",
      "alt": ""
    }
  })]), _vm._v(" "), _c('p', {
    staticClass: "error-info"
  }, [_c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.errors.has('password') && _vm.showError.password),
      expression: "errors.has('password') && showError.password"
    }]
  }, [_vm._v(_vm._s(_vm.errors.first("password")))])])]), _vm._v(" "), (!_vm.isLoading) ? _c('button', {
    staticClass: "form-submit line-button return-data",
    on: {
      "click": _vm.doLogin
    }
  }, [_vm._v("\n    " + _vm._s(_vm.$t("loginText")) + "\n  ")]) : _vm._e(), _vm._v(" "), _c('spinner', {
    staticClass: "spinner-component",
    attrs: {
      "show": _vm.isLoading
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "forgot-password"
  }, [_c('router-link', {
    attrs: {
      "to": "/forgotpw"
    }
  }, [_vm._v(_vm._s(_vm.$t("forgotPassword")))]), _vm._v(" "), _c('router-link', {
    staticClass: "register",
    attrs: {
      "to": "/register"
    }
  }, [_vm._v(_vm._s(_vm.$t('signUp')))])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-280ba749!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/loginform/phoneLogin/PhoneLogin.vue
// module id = 1286
// module chunks = 1